import SignUp from "components/SignUp";
import { Container } from "react-bootstrap";
import { AuthProvider } from "contexts/AuthContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Visitor from "components/Visitor";
import Admin from "components/Admin";
import Login from "components/Login";
import PrivateRoute from "components/PrivateRoute";
import ForgotPassword from "components/ForgotPassword";
import UpdateProfile from "components/UpdateProfile";

const App = () => {
  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-100" style={{ maxWidth: "400px" }}>
        <Router>
          <AuthProvider>
            <Switch>
              <Route exact path="/" component={Visitor} />
              <PrivateRoute path="/update-profile" component={UpdateProfile} />
              <PrivateRoute exact path="/admin" component={Admin} />
              {/* <Route path="/signup" component={SignUp} /> */}
              <Route path="/login" component={Login} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/pilot" component={Visitor} />
            </Switch>
          </AuthProvider>
        </Router>
      </div>
    </Container>
  );
};

export default App;
